import React, { forwardRef } from 'react';
import { Input } from './input';

interface PhoneInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  error?: string;
}

export const PhoneInput = forwardRef<HTMLInputElement, PhoneInputProps>(
  ({ error, className = '', ...props }, ref) => {
    return (
      <Input
        ref={ref}
        type="tel"
        inputMode="tel"
        autoComplete="tel"
        placeholder="+1 (555) 123-4567"
        {...props}
        error={error}
        className={className}
      />
    );
  }
);

PhoneInput.displayName = 'PhoneInput';
